module.exports = __webpack_public_path__ + "img/shield-fill.f02a94ae.svg";